module.exports = "/images/vendor/flag-icon-css/flags/1x1/vi.svg?0aa782108fb39a7d5f3a3076c5a36b72";